import API from '@/assets/libraries/API_Requests';
import { transformScriptArray, removeNulls } from '@/helpers/commonFunctions';
import { OfflineModeShowManager } from '@/services/OfflineMode';
// import { getFromLocalStorage, setToLocalStorage } from '@/helpers/localStorage';
// import moment from 'moment';

const GLOBAL_LOCAL_COMPARE = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });
const SORT_BY_VALUES = { MOST_RECENT: 'MOST_RECENT', LAST_LOADED: 'LAST_LOADED', CREATED_DATE: 'CREATED_DATE', LAST_EDITED_DATE: 'LAST_EDITED_DATE', FIRMWARE_VERSION: 'FIRMWARE_VERSION', SHOW_DATE: 'SHOW_DATE', NAME: 'NAME' };

export const __sortShows = (a, b, sort_by, sort_direction = 1) => {
	let direction = sort_direction;

	let a_value = undefined;
	let b_value = undefined;
	if (sort_by == SORT_BY_VALUES.MOST_RECENT) {
		a_value = __getNewestDateForShow(a);
		b_value = __getNewestDateForShow(b);
	} else {
		let sort_by_key = undefined;
		switch (sort_by) {
			case SORT_BY_VALUES.LAST_LOADED:
				sort_by_key = 'last_loaded';
				break;
			case SORT_BY_VALUES.CREATED_DATE:
				sort_by_key = 'created_date';
				break;
			case SORT_BY_VALUES.LAST_EDITED_DATE:
				sort_by_key = 'last_edited';
				break;
			case SORT_BY_VALUES.FIRMWARE_VERSION:
				sort_by_key = 'firmware_version';
				break;
			case SORT_BY_VALUES.SHOW_DATE:
				sort_by_key = 'show_date';
				break;
			case SORT_BY_VALUES.NAME:
				sort_by_key = 'custom_name';
				break;
		}

		a_value = a[sort_by_key];
		b_value = b[sort_by_key];
	}

	// let a_value = getSafeString(_parseArrayNotation(column.value_key ?? column.id, a));
	// let b_value = getSafeString(_parseArrayNotation(column.value_key ?? column.id, b));
	// console.log('a', a_value, b_value, typeof(a_value), typeof(b_value))

	if (a_value == undefined || (typeof a_value == 'string' && a_value.trim() == '')) {
		return direction;
	}
	if (b_value == undefined || (typeof b_value == 'string' && b_value.trim() == '')) {
		return -direction;
	}

	if (a_value instanceof Date && b_value instanceof Date) {
		//Handle dates
		if (a_value < b_value) {
			return direction;
		}
		return -direction;
	}

	let comparison_value = GLOBAL_LOCAL_COMPARE.compare(a_value, b_value);
	return comparison_value == 0 ? 0 : comparison_value > 0 ? direction : -direction;
};

const __getNewestDateForShow = (show_data) => {
	let created_date = show_data.created_date != undefined ? new Date(show_data.created_date) : undefined;
	let edited_date = show_data.last_edited != undefined ? new Date(show_data.last_edited) : undefined;

	if (created_date == undefined && edited_date != undefined) {
		return edited_date;
	}
	if (edited_date == undefined && created_date != undefined) {
		return created_date;
	}
	if (created_date < edited_date) {
		return edited_date;
	}
	return created_date;
};

export function searchShow(shows, search_term, selected_show) {
	const currently_viewing_show_id = selected_show?.show_ID;

	if (search_term == undefined || null) {
		search_term = '';
	}

	let matched_shows = [];
	let currently_viewing_show_still_matches_search_term = false;

	for (let i = 0; i < shows.length; i++) {
		let show_data = shows[i];

		if (search_term == '') {
			matched_shows.push(show_data);
			continue;
		}

		let name_to_search = show_data.custom_name == undefined ? show_data.show_name : show_data.custom_name;

		if (show_data.show_ID.toLowerCase() == search_term || contains(name_to_search, search_term) || contains(show_data.firmware_version_text, search_term) || contains(show_data.show_category, search_term) || contains(show_data.custom_columns, search_term)) {
			matched_shows.push(show_data);

			if (show_data.show_ID == currently_viewing_show_id) {
				currently_viewing_show_still_matches_search_term = true;
			}
			continue;
		}
	}

	return { matched_shows, currently_viewing_show_still_matches_search_term };
}

function contains(value, term) {
	if (value == undefined || null) {
		return false;
	}
	if (typeof value == 'string') {
		value = value.toLowerCase();
	} else {
		value = value.toString();
	}
	if (value.indexOf(term) > -1) {
		return true;
	}
	return false;
}

export const getUsersShows = async ({ search = undefined, page = 0, limit = undefined, column_to_sort = undefined, column_sort = undefined, include_event_data = true }) => {
	try {
		var query_params = new URLSearchParams();
		query_params.set('page', page);

		if (search != undefined && typeof search == 'string' && search != '') {
			query_params.set('search', search);
		}
		if (include_event_data != undefined) {
			query_params.set('include_event_data', include_event_data);
		}
		if (column_to_sort != undefined && typeof column_to_sort == 'string' && column_to_sort != '') {
			query_params.set('column_to_sort', column_to_sort);
		}
		if (column_sort != undefined && typeof column_sort == 'string' && column_sort != '') {
			query_params.set('column_sort', column_sort);
		}
		if (limit != undefined) {
			query_params.set('limit', limit);
		}

		const response = await API.Call('GET', `${API.CSC_API_URL}/shows/search?${query_params.toString()}`);

		if (response.error != undefined) {
			if (response.error?.title == 'NO_NETWORK_CONNECTION') {
				//Fallback to local data
				let shows = await OfflineModeShowManager.getAllShows();
				shows = removeNulls(shows);
				shows = transformScriptArray(shows);
				console.log('Loaded local shows data', shows);

				if (search != undefined && typeof search == 'string' && search != '') {
					search = search.toLowerCase();
					shows = shows.filter((show) => {
						if (show.show_ID?.toLowerCase().includes(search)) {
							return true;
						}
						if (show.show_code?.toLowerCase().includes(search)) {
							return true;
						}
						if (show.firmware_version_text?.toLowerCase().includes(search)) {
							return true;
						}
						if (show.custom_name?.toLowerCase().includes(search)) {
							return true;
						}

						return false;
					});
				}

				return { shows, pagination: { has_next_page: false, has_previous_page: false, total_pages: 1 } };
			}

			throw new Error(JSON.stringify(response.error));
		}

		let shows = removeNulls(response.shows);
		shows = transformScriptArray(shows);

		for (const show of shows) {
			OfflineModeShowManager.updateShow(show).catch((error) => {
				console.log('Error storing show locally', error);
			});
		}

		return { shows, pagination: response.pagination };
	} catch (error) {
		throw new Error(error);
	}
};

export async function submitNewShow({ show_name, custom_columns, firmware_version, estimated_show_duration, show_type, equipment_manufacture, disable_firing_groups = undefined, defined_positions = undefined }) {
	try {
		if (estimated_show_duration) {
			//Convert minutes to seconds
			estimated_show_duration = estimated_show_duration * 60;
		}

		if (firmware_version < 6) {
			show_type = null;
		}

		const body = removeNulls({ custom_name: show_name, custom_columns, firmware_version, show_type, estimated_show_duration, equipment_manufacture, disable_firing_groups, source: 'ELEVATE_STUDIO', defined_positions });
		const response = await API.Call('POST', `${API.CSC_API_URL}/shows`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function createImportedShow(imported_show) {
	try {
		const response = await API.Call('POST', `${API.CSC_API_URL}/shows`, imported_show);
		if (response.error != undefined) {
			throw new Error(JSON.stringify(response.error));
		}

		return response;
	} catch (error) {
		throw new Error(error);
	}
}
// TODO: Shall be used to create duplicate show in my shows modal.
export async function duplicateShow(show_id) {
	try {
		const response = await API.Call('POST', `${API.CSC_API_URL}/shows/copy/${show_id}`, {});
		if (response.error != undefined) {
			throw new Error(JSON.stringify(response.error));
		}

		const show = transformScriptArray(response.show);

		return show[0];
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function deleteShow(show_id) {
	try {
		const response = await API.Call('DELETE', `${API.CSC_API_URL}/shows/${show_id}`, {});
		if (response.error != undefined) {
			throw new Error(JSON.stringify(response.error));
		}

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function getShowStats(show_info) {
	let number_of_total_rows = 0;
	let number_of_cues = 0;
	let number_of_unaddressed_cues = 0;
	let number_of_events = 0;
	let number_of_steps = 0;
	let number_of_pyro_events = 0;
	let number_of_dmx_events = 0;
	let number_of_alternates = 0;
	let number_of_comments = 0;

	let used_cues = {}; //{CHANNEL: [CUES]}
	let used_unique_cues = {}; // { EVENT_TIME_STRING: { CHANNEL: [CUE] } } //To match Control Panel, Scott wants number of pyro events calculated by uniqueness based on event_time, channel, and cue values.

	for (const event of show_info.events) {
		number_of_total_rows++;
		if (event.isCOMMENT == true) {
			number_of_comments++;
			continue;
		}
		if (event.isALTERNATE1 == true || event.isALTERNATE2 == true) {
			number_of_alternates++;
			continue;
		}
		if (event.isSTEP == true) {
			number_of_steps++;
		}
		if (event.isDMX == true) {
			number_of_dmx_events++;
			continue;
		} //Order is important - A STEP DMX cue would count 1 toward number_DMX, number_events, and number_STEPS.
		if (event.isDMX != true && event.isSTEP == true) {
			number_of_pyro_events++;
			continue;
		} //STEP events are to be considered unique.

		if (event.channel != undefined && event.cue != undefined && (used_cues[event.channel] == undefined || used_cues[event.channel].indexOf(event.cue) == -1)) {
			//Cue and channel is unique
			number_of_cues++;
			if (used_cues[event.channel] == undefined) {
				used_cues[event.channel] = [event.cue];
			} else {
				used_cues[event.channel].push(event.cue);
			}
		}

		let event_time = event.timeline_event_time;
		if (event.channel != undefined && event.cue != undefined && (used_unique_cues[event_time] == undefined || used_unique_cues[event_time][event.channel] == undefined || used_unique_cues[event_time][event.channel].includes(event.cue) == false)) {
			number_of_pyro_events++;
			if (used_unique_cues[event_time] == undefined) {
				used_unique_cues[event_time] = {};
			}
			if (used_unique_cues[event_time][event.channel] == undefined) {
				used_unique_cues[event_time][event.channel] = [];
			}
			used_unique_cues[event_time][event.channel].push(event.cue);
		}

		if (event.channel == undefined || event.cue == undefined) {
			number_of_unaddressed_cues++;
		}
	}

	number_of_events = number_of_pyro_events + number_of_dmx_events;

	return {
		number_of_total_rows,
		number_of_cues,
		number_of_unaddressed_cues,
		number_of_events,
		number_of_steps,
		number_of_pyro_events,
		number_of_dmx_events,
		number_of_alternates,
		number_of_comments,
	};
}

export async function saveShow(show_info) {
	try {
		const obj_to_pass = show_info;
		const response = await API.Call('PUT', `${API.CSC_API_URL}/shows/${show_info.show_ID}`, obj_to_pass);

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export const getShow = async (show_id) => {
	try {
		const response = await API.Call('GET', `${API.CSC_API_URL}/shows/${show_id}`);

		if (response.error != undefined) {
			if (response.error?.title == 'NO_NETWORK_CONNECTION') {
				//Fallback to local data
				let show = await OfflineModeShowManager.getShow(show_id);
				show = transformScriptArray([show])[0];
				return { show };
			}

			throw new Error(JSON.stringify(response.error));
		}

		let show = transformScriptArray([response]);

		if (show[0] != undefined) {
			OfflineModeShowManager.updateShow(show[0]).catch((error) => {
				console.log('Error storing show locally', error);
			});
		}

		return { show: show[0] };
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
};

export async function updateShowAttributes(show_id, show_attributes) {
	const obj_to_pass = {
		script_atributes: show_attributes,
	};
	const response = await API.Call('PUT', `${API.CSC_API_URL}/shows/${show_id}`, obj_to_pass);
	if (response.error != undefined) {
		throw new Error(JSON.stringify(response.error));
	}

	return response;
}

export async function updateShow(show_id, show_info) {
	const response = await API.Call('PUT', `${API.CSC_API_URL}/shows/${show_id}`, show_info);
	if (response.error != undefined) {
		throw new Error(JSON.stringify(response.error));
	}

	return response;
}

/** NOTE: uncomment for debugging */
// export async function submitShowRevisionLog({ show_id, was_successful, was_offline_sync, events, error }) {
// 	let log_object = undefined;
// 	try {
// 		log_object = {
// 			show_id,
// 			performed_on: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
// 			was_successful,
// 			was_offline_sync,
// 			number_of_events: events?.length,
// 			events_array_hash: await sha256HashOfArray(events),
// 			error,
// 		};

// 		const response = await API.Call('POST', `https://api.beta.portal.cobrafiringsystems.com/logs/log_csc_revision_saves`, log_object);
// 		if (response.error != undefined) {
// 			throw new Error(JSON.stringify(response.error));
// 		}

// 		return response;
// 	} catch (error) {
// 		console.log('Error submitting show revsion log', error);

// 		if (log_object != undefined) {
// 			try {
// 				const existing_logs = JSON.parse(getFromLocalStorage('failed_log_revision_saves') ?? '[]');
// 				const stringified_log = JSON.stringify(log_object);
// 				existing_logs.push(stringified_log);
// 				setToLocalStorage('failed_log_revision_saves', JSON.stringify(existing_logs));
// 			} catch (error) {
// 				console.log('Error storing failed log revision saves', error);
// 			}
// 		}

// 		return undefined;
// 	}
// }
